import React, { forwardRef } from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    color: 'white',
    height: 48,
    [`& fieldset`]: {
      borderRadius: '28px',
      [`& legend`]: {
        marginLeft: '16px',
      },
    },
  },
});

interface IInputProps {
  onChange?(e: React.FormEvent): void;
}

const RadiusInput = forwardRef<
  typeof TextField,
  IInputProps & Omit<TextFieldProps, keyof IInputProps>
>(({ className, ...props }, ref) => {
  const classes = useStyles();
  return (
    <TextField
      className={classNames(classes.root, className)}
      margin="normal"
      fullWidth
      inputRef={ref}
      {...props}
    />
  );
});

export default RadiusInput;
